import api from '@/services/api-service';
let translations = undefined;
const currentCulture = 'fi-FI';
if (window.appTranslations !== '#appTranslations') {
  translations = window.appTranslations;
} else {
  api.getTranslations().then((t) => {
    translations = t;
  });
}
window.translationKeys = [];
export default {
  getOrKey(key) {
    window.translationKeys.push(key);
    return translations && translations[key] ? translations[key] : key;
  },
  getCurrentCulture() {
    return currentCulture;
  },
  getCurrentLanguage() {
    return currentCulture.split('-')[0];
  },
};
